import React, {useCallback, useEffect, useState} from 'react';
import styles from './ProgramDescription.module.scss';
import { programMenuOptions, wellbeingFoundationOptions } from '@src/constants';
import { LessonLibraryEnum } from '@types';
import CloseIcon from 'src/assets/icons/close.svg?react';
import Button from 'src/components/button/Button';
import { SllProgram, useMeLazyQuery, useUpdateMeMutation } from '@src/api/graphql-codegen';
import { useUser } from '@src/hooks';

type Props = {
  program?: SllProgram;
  programName: string;
  isAUuser?: boolean;
  isCanada?: boolean;
};

const wellbeingFoundationOptionsList = Object.keys(wellbeingFoundationOptions)

const getDescriptionStatus = (program: string) => {
  switch (program) {
    case programMenuOptions[0].label:
      return {
        isSVDescriptionHidden: true
      }
    case programMenuOptions[1].label:
      return {
        isTDescriptionHidden: true
      }
    case programMenuOptions[3].label:
      return {
        isCCDescriptionHidden: true
      }
    case LessonLibraryEnum.Library:
      return {
        isLLDescriptionHidden: true
      }
    case wellbeingFoundationOptionsList[0]:
      return {
        isSIDescriptionHidden: true
      }
    case wellbeingFoundationOptionsList[1]:
      return {
        isBBDescriptionHidden: true
      }
    case wellbeingFoundationOptionsList[2]:
      return {
        isSBDescriptionHidden: true
      }
  }
}

function ProgramDescription(props: Props) {
  const { programName, program } = props
  const [isVisible, setIsVisible] = useState(false);

  const [user] = useUser(true);

  const [getUser] = useMeLazyQuery({ fetchPolicy: 'network-only' })
  const [updateMe] = useUpdateMeMutation();

  useEffect(() => {
    if (user?.uiStatus && (user?.uiStatus?.isLLDescriptionHidden === getDescriptionStatus(programName)?.isLLDescriptionHidden
      || user?.uiStatus?.isBBDescriptionHidden === getDescriptionStatus(programName)?.isBBDescriptionHidden
      || user?.uiStatus?.isSBDescriptionHidden === getDescriptionStatus(programName)?.isSBDescriptionHidden
      || user?.uiStatus?.isSIDescriptionHidden === getDescriptionStatus(programName)?.isSIDescriptionHidden
      || user?.uiStatus?.isSVDescriptionHidden === getDescriptionStatus(programName)?.isSVDescriptionHidden
      || user?.uiStatus?.isTDescriptionHidden === getDescriptionStatus(programName)?.isTDescriptionHidden
      || user?.uiStatus?.isCCDescriptionHidden === getDescriptionStatus(programName)?.isCCDescriptionHidden
      )) {
      setIsVisible(false)
    } else if (user) {
      setIsVisible(true)
    }
  }, [programName, user])

  const handleOpenMore = () => {
    window.open(program?.learnMoreDesc ?? '/', '_blank');
  }

  const handleHiddenDescription = useCallback(async () => {
    const res = await updateMe({
      variables: {
        input: {
          uiStatus: {
            ...getDescriptionStatus(programName)
          }
        },
      },
    });
    if (res.data?.updateMe) {
      setIsVisible(false);
      await getUser()
    }
  }, [programName, updateMe, getUser])

  if (!isVisible || programName === LessonLibraryEnum.Programs || !program?.bannerDesc) return <></>

  return (
    <div className={styles.programDescription}>
      <div className={styles.content}>
        {program?.description}
        <div>
          <Button size='small' outline={true} className={styles.learnMoreButton} label='LEARN MORE' onClick={handleOpenMore}/>
        </div>
      </div>
      <CloseIcon className={styles.closeIcon} onClick={handleHiddenDescription} />
    </div>
  );
}

export default ProgramDescription;
